import React from 'react';
import PropTypes from 'prop-types';

const ReverseGeoCoding = ({ fill, ...props }) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.5 6.99949C13.5021 7.96375 13.1924 8.90284 12.617 9.67662L9 14.4999L5.383 9.67662C4.95951 9.10443 4.67779 8.43993 4.56099 7.73771C4.44419 7.03548 4.49564 6.31556 4.71111 5.63708C4.92659 4.9586 5.29994 4.34092 5.8005 3.83478C6.30106 3.32864 6.91454 2.94847 7.59057 2.7255C8.26659 2.50254 8.98586 2.44314 9.6893 2.55218C10.3927 2.66122 11.0603 2.9356 11.6371 3.35277C12.2139 3.76994 12.6835 4.31801 13.0073 4.95194C13.3312 5.58588 13.5 6.28761 13.5 6.99949ZM15 6.99949C15 8.33956 14.561 9.57562 13.82 10.5737L9.937 15.7499L9 17L8.062 15.7499L4.18 10.5737C3.61469 9.81106 3.23838 8.92519 3.08199 7.98885C2.9256 7.05251 2.99359 6.09242 3.28039 5.18747C3.56718 4.28252 4.06459 3.45854 4.73175 2.78322C5.3989 2.1079 6.21676 1.60053 7.11812 1.30278C8.01948 1.00503 8.97863 0.925407 9.91675 1.07045C10.8549 1.2155 11.7452 1.58107 12.5145 2.13714C13.2839 2.69321 13.9104 3.42389 14.3424 4.26917C14.7745 5.11444 14.9999 6.05018 15 6.99949ZM9 8.99959C9.53043 8.99959 10.0391 8.78887 10.4142 8.41377C10.7893 8.03868 11 7.52995 11 6.99949C11 6.46903 10.7893 5.96029 10.4142 5.5852C10.0391 5.21011 9.53043 4.99938 9 4.99938C8.46957 4.99938 7.96086 5.21011 7.58579 5.5852C7.21071 5.96029 7 6.46903 7 6.99949C7 7.52995 7.21071 8.03868 7.58579 8.41377C7.96086 8.78887 8.46957 8.99959 9 8.99959Z"
      fill={fill || '#6B6C7B'}
    />
  </svg>
);

ReverseGeoCoding.propTypes = {
  fill: PropTypes.string,
};

export default ReverseGeoCoding;
